module.exports = "/images/vendor/flag-icon-css/flags/4x3/au.svg?503a3a980ccbc651a8acc57b6f6d2dab";